export default __webpack_public_path__ + "static/media/_ice_bullion.d199abb8.png";